import TableAssessmentResetDialog from '../../components/dialogs/TableAssessmentResetDialog';

function ResultsPageDialogs() {
    return <TableAssessmentResetDialog />;
}

export default ResultsPageDialogs;
